import { render } from "./IndexUpcoming.vue?vue&type=template&id=3aa36d4d&scoped=true"
import script from "./IndexUpcoming.vue?vue&type=script&lang=js"
export * from "./IndexUpcoming.vue?vue&type=script&lang=js"

import "./IndexUpcoming.vue?vue&type=style&index=0&id=3aa36d4d&scoped=true&lang=scss"

import exportComponent from "D:\\work\\ocs\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa36d4d"]])

export default __exports__